/**
 * A file is "empty" when it carries no bytes — the symptom of a failed
 * iCloud download. Missing files count as empty too.
 * @param {File} file
 * @returns {boolean}
 */
export function isEmptyFile(file) {
  return !file || file.size === 0
}

/**
 * @param {File[] | FileList} files
 * @returns {number}
 */
export function countEmptyFiles(files) {
  return Array.from(files ?? []).filter(isEmptyFile).length
}
